if (document.body.clientWidth < 1000) {
  function accordionFooter(params) {
    const selectors = {
      accordionTitle: "[data-accordion-title]",
      accordionContent: "[data-accordion-Content]",
      arrowDown: "[data-arrow-down]",
      arrowUp: "[data-arrow-up]",
    };
    const accordionTitle = document.querySelectorAll(selectors.accordionTitle);
    const accordionContent = document.querySelectorAll(
      selectors.accordionContent
    );
    const arrowDown = document.querySelectorAll(selectors.arrowDown);
    const arrowUp = document.querySelectorAll(selectors.arrowUp);
    let clickOn;

    accordionTitle.forEach((accordion, index) => {
      accordion.addEventListener("click", function () {
        accordionContent.forEach((content) => {
          content.classList.add("hidden");
        });
        arrowDown.forEach((arrow) => {
          arrow.classList.remove("hidden");
        });
        arrowUp.forEach((arrow) => {
          arrow.classList.add("hidden");
        });
        if (clickOn == undefined) {
          clickOn = index;
          accordionContent[index].classList.remove("hidden");
          arrowDown[index].classList.add("hidden");
          arrowUp[index].classList.remove("hidden");
        } else {
          if (index == clickOn) {
            clickOn = -1;
            accordionContent[index].classList.add("hidden");
          } else {
            clickOn = index;
            accordionContent[index].classList.remove("hidden");
            arrowDown[index].classList.add("hidden");
            arrowUp[index].classList.remove("hidden");
          }
        }
      });
    });
  }
  accordionFooter();
}
